import { menuItemWithIcon } from "../../types/common";
import { ReactComponent as OverviewIcon } from "../../assets/icons/overview.svg";
import { ReactComponent as GanttChartIcon } from "../../assets/icons/gantt-chart.svg";
import { ReactComponent as CalendarSettingsIcon } from "../../assets/icons/gear.svg";
import { ReactComponent as PeopleIcon } from "../../assets/icons/people.svg";

import NavgationListItem from "./NavigationListItem";
import navigationStyles from "../../styles/navigation.module.css";
import { useLocation } from "react-router-dom";
import {
  isConstraintShown,
  isCalendarSettingsShown,
} from "../../utils/environmentUtils";

const PageNavigation = () => {
  const location = useLocation();

  const pageNavigationMenu: menuItemWithIcon[] = [
    {
      icon: <OverviewIcon width={16} height={16} />,
      title: "Oversigt", //To do: move to labels.
      redirectUrl: "/overview" + location.search,
    },
    {
      icon: <GanttChartIcon width={16} height={16} />,
      title: "Tidsplan",
      redirectUrl: "/ganttChart" + location.search,
    },
  ];

  if (isConstraintShown) {
    pageNavigationMenu.push({
      icon: <PeopleIcon width={16} height={16} />,
      title: "Hensyn",
      redirectUrl: "/constraint" + location.search,
    });
  }

  if (isCalendarSettingsShown) {
    pageNavigationMenu.push({
      icon: <CalendarSettingsIcon width={16} height={16} />,
      title: "Calendar",
      redirectUrl: "/calendarSettings" + location.search,
    });
  }

  return (
    <section className={navigationStyles.navigationList}>
      <nav
        id="navigation"
        tabIndex={-1}
        className={navigationStyles.navigationListMenuWrapper}
      >
        {pageNavigationMenu.map((menuItem, index) => (
          <NavgationListItem menuItem={menuItem} key={index} />
        ))}
      </nav>
    </section>
  );
};

export default PageNavigation;
